import axiosConfig from "./axiosConfig";

export interface OrganisationUserPayload {
  email: string;
  [key: string]: any;
}

const postOrganisationUser = async (
  authToken: string,
  orgId: string,
  payload: OrganisationUserPayload,
  userOrgId?: string
): Promise<void> => {
  const { data } = await axiosConfig.post(
    `/organisation/${orgId}/user${userOrgId ? `?userOrgId=${userOrgId}` : ""}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postOrganisationUser;
